import { useAtomValue } from 'jotai/index';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useMemo } from 'react';
import { ArticleDetailUtil, EArticleClass } from 'shared/models';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useTranslation } from 'react-i18next';
import { useArticleDescription } from './use-article-description';
import { unescapeSpecialXmlCharacter } from '~/utils/escape-xml';

export const useArticleTitle = (): string => {
  const article = useAtomValue($CurrentArticle);
  const { t } = useTranslation();
  const description = useArticleDescription();

  return useMemo(() => {
    const articleAvailable = ArticleDetailUtil.isArticleAvailable(article);

    if (!articleAvailable) {
      return `${t('article_not_found')} | Lemon8`;
    }

    let { title = '' } = article;

    // 2. if title not exists, use part of description as title.
    if (!title) {
      title = unescapeSpecialXmlCharacter(description.replace(/\s+/g, ' ')).slice(0, 30);
    }

    // 3. append suffix according to article class
    if (article.articleClass === EArticleClass.GALLERY) {
      title += ` | ${t('user_published_gallery').replace('%s', article.author.nickName)} | Lemon8`;
    } else if (article.articleClass === EArticleClass.VIDEO) {
      title += ` | ${t('own_video').replace('%s', article.author.nickName)} | Lemon8`;
    } else {
      title += ` | ${t('user_published_article').replace('%s', article.author.nickName)} | Lemon8`;
    }

    return title;
  }, [article]);
};
